<template>
    <div class="container">
      <app-header title="联系客服"/>
      <!--<div class="hint">联系我们</div>-->
      <!--<div class="custom">-->
        <!--<template  v-for="item in list">-->
          <!--<div class="custom-item">-->
            <!--<div class="custom-left" style="background:rgba(254,0,59,1);">-->
              <!--<img src="@/assets/servicePhone.png" width="21px" height="21px" class="custom-img"/>-->
            <!--</div>-->
            <!--<div class="custom-right">-->
              <!--<div class="custom-name ellipsis">{{item.name}}</div>-->
              <!--<div class="custom-code ellipsis">{{item.code}}</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</template>-->
      <!--</div>-->
      <div class="serviceAll">
        <template  v-for="item in list">
          <div class="all" @click="callPhone(item.code)" v-if="item.type==0">
            <div class="allimg">
              <img src="@/assets/servicePhone.png" width="21px" height="21px"/>
            </div>
            <div class="relation-right">
              <div class="relationTitle">{{item.name}}</div>
              <div class="relation">{{item.code}}</div>
            </div>
          </div>
          <div class="all"  v-if="item.type==1" @click="toLinkQQ(item.code)">
            <a target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&uin='+item.code+'&site=qq&menu=yes'" style="display: flex">
              <div class="allimg" style="background: #FEA900">
                <img src="@/assets/QQ.png" width="21px" height="21px"/>
              </div>
              <div class="relation-right">
                <div class="relationTitle">{{item.name}}</div>
                <div class="relation">{{item.code}}</div>
              </div>
            </a>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
  import {getSysSetting,getSysCustomList} from '@/api/system/index'
  export default {
    name: "index",
    data () {
      return {
        shows: false,
        list: [],
        row: {
          phone: '0755-258963',
          qq: '568966232'
        }
      }
    },
    created () {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
        /(Android)/i.test(navigator.userAgent)
      ) {
        this.shows = true;
      }
      this.getSysCustomList()
    },
    methods: {
      toLinkQQ(qq){
        // let url = 'http://wpa.qq.com/msgrd?v=3&uin='+ qq +'&site=qq&menu=yes';
        // window.open(url,'_blank')
      },
      callPhone (phone) {
        window.location.href = 'tel://' + phone
      },
      getSysCustomList(){
        getSysCustomList({}).then(res=>{
          if (res.success){
            this.list = res.data
          }
        })
      },
      getSysSetting(){
        getSysSetting({id: 1}).then(res=>{
          if (res.success){
            this.row = res.data
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .container{
      .hint{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:39px;
        color:rgba(51,51,51,1);
        opacity:1;
        padding: 15px;
      }
      .serviceAll{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 15px;
        width: 100%;
        box-sizing: border-box;
        .all{
          display: flex;
          width:49%;
          height:63px;
          background:rgba(243,243,243,1);
          border-radius:2px;
          margin-bottom: 5px;
          padding: 10px;
          box-sizing: border-box;
          .allimg{
            width:2.5rem;
            height:2.5rem;
            line-height: 53px;
            text-align: center;
            background:rgba(254,0,59,1);
            border-radius:50%;
            margin-right: 5px;
          }
          .relation-right{
            /*width: 6rem;*/
          }
          .relationTitle{
            width: 6rem;
            height: 20px;
            line-height: 20px;
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            overflow: hidden;
          }
          .relation{
            width: 6rem;
            height: 20px;
            line-height: 20px;
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            overflow: hidden;
            word-wrap: break-word;
            word-break: break-all;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/mine/service/index.vue